import { render, staticRenderFns } from "./ModalCriarEditarSubEspecialidade.vue?vue&type=template&id=73616aa6&scoped=true"
import script from "./ModalCriarEditarSubEspecialidade.vue?vue&type=script&lang=ts"
export * from "./ModalCriarEditarSubEspecialidade.vue?vue&type=script&lang=ts"
import style0 from "./ModalCriarEditarSubEspecialidade.vue?vue&type=style&index=0&id=73616aa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73616aa6",
  null
  
)

export default component.exports